import { Component, ViewContainerRef, inject, OnInit } from '@angular/core';
import { SystemViewNewComponent } from './system-view-new/system-view-new.component';

/**
 * Wrapper histórico da escolha de moldura. A moldura Material antiga
 * (SystemViewComponent) foi aposentada em 2026-08 — todos os layouts
 * (light, dark, light_modern, vault, custom) usam a moldura NG-Zorro
 * (SystemViewNewComponent); a paleta é aplicada pelo próprio componente
 * via change()/reload(), então trocar de layout não recria a moldura.
 *
 * O componente continua existindo porque as rotas (app.module) e o
 * menu-service ancoram as rotas-filhas nele.
 */
@Component({
  selector: 'system-view-layout-selector',
  template: `<ng-container #container></ng-container>`,
  standalone: false
})
export class SystemViewLayoutSelectorComponent implements OnInit {
  private viewContainer = inject(ViewContainerRef);

  ngOnInit(): void {
    this.viewContainer.createComponent(SystemViewNewComponent);
  }
}
